"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = __importDefault(require("./Box"));
var RadioButtonGroup = styled_components_1["default"](Box_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n\n  & > label {\n    flex: 1;\n\n    &:first-child div[data-name='radio-button'] {\n      border-radius: 25px 0 0 25px;\n    }\n\n    &:last-child div[data-name='radio-button'] {\n      border-radius: 0 25px 25px 0;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n\n  & > label {\n    flex: 1;\n\n    &:first-child div[data-name='radio-button'] {\n      border-radius: 25px 0 0 25px;\n    }\n\n    &:last-child div[data-name='radio-button'] {\n      border-radius: 0 25px 25px 0;\n    }\n  }\n"])));
RadioButtonGroup.displayName = 'RadioButtonGroup';
RadioButtonGroup.defaultProps = {
    width: 1
};
exports["default"] = RadioButtonGroup;
var templateObject_1;
//# sourceMappingURL=RadioButtonGroup.js.map